import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Slider from "../../pages/Home/Slider";
import BlogData from "../../pages/Home/BlogData";
import { FiHeadphones } from "react-icons/fi";
import { Link } from "react-router-dom";

import "./Home.css";
import FAQSection from "../../pages/Home/FAQSection";
import RashiSection from "../../pages/Home/RashiSection";
import CategorySection from "../../pages/Home/CategorySection";
import RudrakshaSection from "../../components/RudrakshaSection/RudrakshaSection";
import GemstonesSection from "../../components/GemstonesSection/GemstonesSection";
import ConchShellSection from "../../components/ConchShellSection/ConchShellSection";
import CrystalsSection from "../../components/CrystalsSection/CrystalsSection";
import VastuProductsSection from "../../components/VastuProductsSection/VastuProductsSection";
import TulsiSection from "../../components/TulsiSection/TulsiSection";
import PoojaEssentialsSection from "../../components/PoojaEssentialsSection/PoojaEssentialsSection";
import Shaligram from "../../components/shaligram/shaligram";
import ShivlingSection from "../../components/ShivlingSection/shivlingSection";
import SacredCommunity from "../../pages/Home/SacredCommunity";
import Reviews from "../../components/Reviews/Reviews";
import PerfumeSection from "../../components/PerfumeSection/PerfumeSection";
// import { HiArrowRight } from "react-icons/hi";
// import { FaStar } from "react-icons/fa";
import CategoryGate from "../../components/CategoryGate/CategoryGate";
// import WhatsAppButton from "../../components/WhatsAppButton/WhatsAppButton";
import { Helmet } from "react-helmet-async";
import BASE_URL from "../../config";
import { getTopRatedProducts } from "../../api/productApi";
// import video1 from "../../assets/images/product-video1.mp4";
// import video2 from "../../assets/images/product-video2.mp4";
// import video3 from "../../assets/images/product-video3.mp4";
// import video4 from "../../assets/images/product-video4.mp4";
// import video5 from "../../assets/images/product-video5.mp4";
// import { FiHeadphones } from "react-icons/fi";
// const videos = [
//   {
//     id: 1,
//     video: video1,
//     title: "Rudrakshas",
//   },
//   {
//     id: 2,
//     video: video2,
//     title: "Gemstones",
//   },
//   {
//     id: 3,
//     video: video3,
//     title: "Crystals & Healing Stones",
//   },
//   {
//     id: 4,
//     video: video4,
//     title: "Conch Shells & Shaligrams",
//   },
//   {
//     id: 5,
//     video: video5,
//     title: "Vastu Products",
//   },
// ];

const Home = () => {
  const navigate = useNavigate();
  const [perfumeProducts, setPerfumeProducts] = useState([]);
  const [loadingPerfumes, setLoadingPerfumes] = useState(true);
  const [perfumeError, setPerfumeError] = useState("");

  // Uploaded images come back as "/uploads/..." unless the backend serves them from a CDN.
  const getImageSrc = (url) => {
    if (!url) return "/placeholder.png";
    if (/^https?:\/\//.test(url)) return url;
    return `${BASE_URL.replace(/\/api\/v1\/?$/, "")}${url}`;
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchProducts = async () => {
      try {
        setLoadingPerfumes(true);
        setPerfumeError("");

        // Products rated above 3 across every category and subcategory
        const products = await getTopRatedProducts({
          limit: 20,
          signal: controller.signal,
        });

        setPerfumeProducts(products);
      } catch (error) {
        if (error?.name === "AbortError") return;
        console.error("Top rated products API Error:", error);
        setPerfumeError(error.message || "Products could not be loaded.");
      } finally {
        if (!controller.signal.aborted) setLoadingPerfumes(false);
      }
    };

    fetchProducts();

    return () => controller.abort();
  }, []);

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>Authentic Rudraksha & Gemstones | AstroLogical Solutions</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover authentic Rudraksha, gemstones, healing crystals, Vastu products, Yantras & more. Shop trusted spiritual products for a balanced, mindful life today."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://astrologicalsolutions.in/" />

        {/* Robots */}
        <meta name="robots" content="index, follow, max-image-preview:large" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Authentic Rudraksha & Gemstones | AstroLogical Solutions"
        />

        <meta
          property="og:description"
          content="Discover authentic Rudraksha, gemstones, healing crystals, Vastu products, Yantras & more. Shop trusted spiritual products for a balanced, mindful life today."
        />

        <meta property="og:url" content="https://astrologicalsolutions.in/" />

        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="Astro Logical Solutions" />

        <meta
          property="og:image"
          content="https://astrologicalsolutions.in/og/homepage-banner.jpg"
        />

        <meta
          property="og:image:alt"
          content="Authentic Rudraksha, gemstones and spiritual products from Astro Logical Solutions"
        />

        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Authentic Rudraksha & Gemstones | AstroLogical Solutions"
        />

        <meta
          name="twitter:description"
          content="Discover authentic Rudraksha, gemstones, healing crystals, Vastu products, Yantras and more."
        />

        <meta
          name="twitter:image"
          content="https://astrologicalsolutions.in/og/homepage-banner.jpg"
        />

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://astrologicalsolutions.in/#organization",
            name: "Astro Logical Solutions",
            url: "https://astrologicalsolutions.in/",
            logo: "https://astrologicalsolutions.in/static/media/Logo-New.781e0d31c7c6d2020df4.png",
            image:
              "https://astrologicalsolutions.in/static/media/Logo-New.781e0d31c7c6d2020df4.png",
            telephone: "+91-9690513751",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Shiva Aangan, Bachan Singh Colony, Lane No. 9",
              addressLocality: "Muzaffarnagar",
              addressRegion: "Uttar Pradesh",
              postalCode: "251001",
              addressCountry: "IN",
            },
            sameAs: [
              "https://www.facebook.com/astrologicalsolutions77",
              "https://www.instagram.com/astro_logical_solutions/",
            ],
          })}
        </script>
      </Helmet>

      <Header />
      <Slider />
      <CategorySection />
      <CategoryGate slugs={["rudraksha"]}>
        <RudrakshaSection />
      </CategoryGate>
      <CategoryGate slugs={["shivling"]}>
        <ShivlingSection />
      </CategoryGate>
      <CategoryGate slugs={["shankh-sea-shells"]}>
        <ConchShellSection />
      </CategoryGate>
      <CategoryGate slugs={["shaligram"]}>
        <Shaligram />
      </CategoryGate>
      <CategoryGate slugs={["gemstones"]}>
        <GemstonesSection />
      </CategoryGate>
      <CategoryGate slugs={["shop-by-astrology"]}>
        <RashiSection />
      </CategoryGate>
      <br />
      <CategoryGate slugs={["crystals"]}>
        <CrystalsSection />
      </CategoryGate>
      <CategoryGate slugs={["vastu-products"]}>
        <VastuProductsSection />
      </CategoryGate>

      <CategoryGate slugs={["pooja"]}>
        <PoojaEssentialsSection />
      </CategoryGate>
      <section className="bestSelling">
        <div className="sectionHeader">
          <div className="titleArea">
            <h2>Our Product Collection</h2>
          </div>
        </div>

        {loadingPerfumes ? (
          <p>Loading products...</p>
        ) : perfumeError ? (
          <p>{perfumeError}</p>
        ) : perfumeProducts.length === 0 ? (
          <p>No products available.</p>
        ) : (
          <div className="productSliderWrapper">
            <button
              className="sliderArrow prevArrow"
              onClick={() =>
                document.querySelector(".productSlider")?.scrollBy({
                  left: -280,
                  behavior: "smooth",
                })
              }
              aria-label="Previous products"
            >
              &#10094;
            </button>

            <div className="productSlider">
              {perfumeProducts.map((item) => (
                <div className="productCard" key={item.id}>
                  <img
                    src={getImageSrc(
                      item.images?.find((img) => img?.isPrimary)?.imageUrl ||
                        item.images?.[0]?.imageUrl,
                    )}
                    alt={item.name || "Product"}
                  />

                  <div className="cardBody">
                    <h4>{item.name || item.title}</h4>

                    {item.reviewSummary?.totalReviews > 0 && (
                      <p className="cardRating">
                        <span aria-hidden="true">★</span>{" "}
                        {Number(item.reviewSummary.averageRating).toFixed(1)}
                        <span className="cardRatingCount">
                          {" "}
                          ({item.reviewSummary.totalReviews})
                        </span>
                      </p>
                    )}

                    <h5>₹{Number(item.price || 0).toLocaleString("en-IN")}</h5>

                    <button
                      className="viewProductBtn"
                      onClick={() =>
                        navigate(`/product/${item.slug || item.id}`)
                      }
                    >
                      View Product
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="sliderArrow nextArrow"
              onClick={() =>
                document.querySelector(".productSlider")?.scrollBy({
                  left: 280,
                  behavior: "smooth",
                })
              }
              aria-label="Next products"
            >
              &#10095;
            </button>
          </div>
        )}
      </section>
      <CategoryGate slugs={["perfumes"]}>
        <PerfumeSection />
      </CategoryGate>
      <CategoryGate slugs={["tulsi"]}>
        <TulsiSection />
      </CategoryGate>
      {/* <section className="video-section">
        <div className="container">
          <h2 className="video-heading">Sacred Rudraksha Collection</h2>

          <p className="video-subtitle">
            Rudraksha in Motion – See the Beads. Feel the Power.
          </p>

          <div className="video-grid">
            {videos.map((item) => (
              <div className="video-card" key={item.id}>
                <video src={item.video} autoPlay muted loop playsInline />
                <h4>{item.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      <Reviews showPhotos={false} />
      <BlogData />

      <FAQSection />
      <SacredCommunity />
      <section className="support-section">
        <div className="support-content">
          <h2>Need Support? Get Consultation Now!</h2>

          <p>Need to chat with us? We are happy to assist you.</p>

          <Link to="/contact" className="support-btn">
            <FiHeadphones />
            Get Support
          </Link>
        </div>
      </section>
      <Footer />
      {/* <WhatsAppButton /> */}
    </>
  );
};

export default Home;
